import colors from 'constants/color'
import { createTheme } from '@mui/material'
import baseTheme from 'config/theme/base'
import { ThemeMode } from 'enums'

const darkTheme = createTheme({
  ...baseTheme,
  palette: {
    ...baseTheme.palette,
    mode: ThemeMode.Dark,
    background: {
      default: colors.githubDark,
      paper: colors.githubDarkAccent,
    },
  },
})

export default darkTheme
